import React, { useContext, useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import {useHistory} from 'react-router-dom';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { IconButton, Typography } from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import VisibilityIcon from '@material-ui/icons/Visibility';
import ListIcon from '@material-ui/icons/List';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import BusinessIcon from '@material-ui/icons/Business';
import PersonIcon from '@material-ui/icons/Person';
import LocalAtmIcon from '@material-ui/icons/LocalAtm';
import LockIcon from '@material-ui/icons/Lock';
import WorkIcon from '@material-ui/icons/Work';
import PowerSettingsNewIcon from '@material-ui/icons/PowerSettingsNew';

import { AuthContext } from '../shared/context/auth-context';

const StyledMenu = withStyles({
  paper: {
    border: '1px solid #d3d4d5',
    marginTop: '8px',
    marginLeft: '16px'
  },
})((props) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'center',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'center',
    }}
    {...props}
  />
));

const StyledMenuItem = withStyles((theme) => ({
  root: {
    '&:focus': {
      backgroundColor: theme.palette.primary.main,
      '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
        color: theme.palette.common.white
      },
    },
    '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
      margin: theme.spacing(-1),
    }
  },
}))(MenuItem);

const CustomizedMenus = () => {
  const auth = useContext(AuthContext);
  const [anchorEl, setAnchorEl] = useState(null);
  let history = useHistory();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const summaryClick = (e) => 
  { 
    e.preventDefault();

    history.replace(`/sommaire`);
  
    handleClose(); 
  }

  const profileClick = (e) => 
  { 
    e.preventDefault();

    history.replace(`/${auth.userId}/profil`);
  
    handleClose(); 
  }

  const contractClick = (e) => 
  { 
    e.preventDefault();

    history.replace(`/${auth.userId}/contrat`);
  
    handleClose(); 
  }

  const clientStatementClick = (e) => 
  { 
    e.preventDefault();

    history.replace(`/${auth.userId}/releve`);
  
    handleClose(); 
  }

  const documentsClick = (e) => 
  { 
    e.preventDefault();

    history.replace(`/${auth.userId}/documents`);
  
    handleClose(); 
  }

  return (
    <div>
      <IconButton
        aria-controls="customized-menu"
        aria-haspopup="true"
        variant="contained"
        color="primary"
        onClick={handleClick}
      >
       <Typography variant='subtitle2'>{auth.userName}</Typography> <MoreVertIcon/>
      </IconButton>
      <StyledMenu
        id="customized-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <StyledMenuItem onClick={summaryClick}>
          <ListItemIcon>
            <VisibilityIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Vue d'ensemble" />
        </StyledMenuItem>
        <StyledMenuItem onClick={clientStatementClick}>
          <ListItemIcon>
            <ListIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Relevé"/>
        </StyledMenuItem>
        <StyledMenuItem  onClick={contractClick}> 
          <ListItemIcon>
            <FileCopyIcon fontSize="small" />
          </ListItemIcon>
            <ListItemText primary="Contrat" />
        </StyledMenuItem>
        <StyledMenuItem disabled>
          <ListItemIcon>
            <BusinessIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Produits" />
        </StyledMenuItem>
        <StyledMenuItem onClick={profileClick}>
          <ListItemIcon>
            <PersonIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Informations personnelles" />
        </StyledMenuItem>
        <StyledMenuItem onClick={profileClick}>
          <ListItemIcon>
            <LocalAtmIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Options de paiement" />
        </StyledMenuItem>
        <StyledMenuItem onClick={profileClick}>
          <ListItemIcon>
            <LockIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Modifier le mot de passe" />
        </StyledMenuItem>
        <StyledMenuItem onClick={documentsClick}>
          <ListItemIcon>
            <WorkIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Documents" />
        </StyledMenuItem>
        <StyledMenuItem onClick={auth.logout}>
          <ListItemIcon>
            <PowerSettingsNewIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Déconnexion" />
        </StyledMenuItem>
      </StyledMenu>
    </div>
  );
}

export default CustomizedMenus;